import { queryOptions, useQuery } from '@tanstack/react-query';

import { productionApi } from '../api/production-api';

import { productionKeys } from './production-keys';

export function orderWorkflowQueryOptions(storeId: string, orderId: string) {
  return queryOptions({
    queryKey: productionKeys.workflow(storeId, orderId),
    queryFn: () => productionApi.workflow(storeId, orderId),
    // 404 means "no workflow yet" (unpaid, or no default template), not a failure worth retrying.
    retry: false,
  });
}

export function useOrderWorkflow(storeId: string, orderId: string, enabled = true) {
  return useQuery({ ...orderWorkflowQueryOptions(storeId, orderId), enabled });
}
